import { HttpClient } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';

import { AuthModule, OpenIdConfiguration, StsConfigHttpLoader, StsConfigLoader, StsConfigStaticLoader } from 'angular-auth-oidc-client';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AppConfig } from 'src/shared/models/app-config.model';
import { AppSettings } from 'src/shared/models/app-settings.model';
import { ConfigService } from 'src/shared/services/config.service';
import version from '../../../version.json';

export const httpLoaderFactory = (httpClient: HttpClient) => {
    var config = {
		'PROD': `oidc-settings.json?ver=${version}`,
		'QA': `oidc-settings.development.json?ver=${version}`,
		'DEV': `oidc-settings.development.json?ver=${version}`,
		'MOCKS': `oidc-settings.development.json?ver=${version}`,
		'DockerLocal': `oidc-settings.dockerlocal.json?ver=${version}`,
	}[environment.type];

    const config$: Observable<OpenIdConfiguration> = httpClient.get<AppConfig>(`${ config }`).pipe(map((customConfig: AppConfig) => {
        console.log ("Loading config...");
        return { 
            authority: customConfig.stsServer,
            autoCleanStateAfterAuthentication: customConfig.auto_clean_state_after_authentication,
            autoUserInfo: customConfig.auto_userinfo,
            clientId: customConfig.client_id,
            forbiddenRoute: customConfig.forbidden_route,
            maxIdTokenIatOffsetAllowedInSeconds: +customConfig.max_id_token_iat_offset_allowed_in_seconds,
            postLoginRoute: customConfig.post_login_route,
            postLogoutRedirectUri: customConfig.post_logout_redirect_uri,
            redirectUrl: customConfig.redirect_url,
            renewTimeBeforeTokenExpiresInSeconds: customConfig.silent_renew_offset_in_seconds,
            responseType: customConfig.response_type,
            scope: customConfig.scope,
            silentRenew: customConfig.silent_renew,
            silentRenewUrl: customConfig.silent_renew_url,
            startCheckSession: customConfig.start_checksession,
            triggerAuthorizationResultEvent: customConfig.trigger_authorization_result_event,
            unauthorizedRoute: customConfig.unauthorized_route,
            useRefreshToken: customConfig.use_refresh_token,
            secureRoutes: customConfig.secureRoutes
        };
    }));

    return new StsConfigHttpLoader(config$);
}

function loadConfig(config: ConfigService): () => Promise<AppSettings> {
	return () => config.load();
}

@NgModule({
    imports: [AuthModule.forRoot({
        loader: {
            provide: StsConfigLoader,
            useFactory: httpLoaderFactory,
            deps: [ HttpClient ]
        }        
    })],
    providers: [{
			provide: APP_INITIALIZER,
			useFactory: loadConfig,
			deps: [ ConfigService ],
			multi: true
    }],
    exports: [ AuthModule ]
})
export class AuthConfigModule {}